"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const safe_json_utils_1 = require("safe-json-utils");
exports.REACT_NATIVE_REQUIRED_OPTION = 'asyncStorage';
function isReactNativeOptions(opts) {
    return exports.REACT_NATIVE_REQUIRED_OPTION in opts;
}
exports.isReactNativeOptions = isReactNativeOptions;
function getReactNativeOptions(opts) {
    if (typeof opts === 'undefined' || !isReactNativeOptions(opts)) {
        throw new Error(`Missing ${exports.REACT_NATIVE_REQUIRED_OPTION} option required for React-Native`);
    }
    return opts;
}
exports.getReactNativeOptions = getReactNativeOptions;
exports.NODE_JS_REQUIRED_OPTION = 'database';
function isNodeJSOptions(opts) {
    return exports.NODE_JS_REQUIRED_OPTION in opts;
}
exports.isNodeJSOptions = isNodeJSOptions;
function getNodeJSOptions(opts) {
    if (typeof opts === 'undefined' || !isNodeJSOptions(opts)) {
        throw new Error(`Missing ${exports.NODE_JS_REQUIRED_OPTION} option required for NodeJS`);
    }
    return opts;
}
exports.getNodeJSOptions = getNodeJSOptions;
function parseEntry(entry) {
    return [entry[0], safe_json_utils_1.safeJsonParse(entry[1])];
}
exports.parseEntry = parseEntry;
//# sourceMappingURL=utils.js.map